import { render, staticRenderFns } from "./playSituation.vue?vue&type=template&id=e24e4334&scoped=true&"
import script from "./playSituation.vue?vue&type=script&lang=js&"
export * from "./playSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e4334",
  null
  
)

export default component.exports